import { combineEpics } from 'redux-observable';
import api from 'api/epics';

export default combineEpics(
  api,
);
